// extracted by mini-css-extract-plugin
module.exports = {"container":"Hospital_container__2TwOO","body":"Hospital_body__2iQvI","box":"Hospital_box__3Uezj","header":"Hospital_header__1nXCC","wrapheader":"Hospital_wrapheader__1gYM_"};